<template>
    <!-- Panel Derecho -->
        <b-col cols="12" md="4">
      <b-row>
        <b-col class="margin-izquierdo">
          <h3 class="color-primary">
            <b-img src="/images/home/banner3.png"  class="mr-2 img-banner-left"></b-img>
          </h3>
          <br>
          <slot></slot>
        </b-col>
      </b-row>
    </b-col>
</template>
<script>
export default {
  name: "Banner-right"
};
</script>